// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"ceec762b","277":"90059bb3","319":"9947d955","453":"cb502c0f","895":"d0722ce3"}[chunkId] + ".chunk.js";
};